module.exports = __webpack_public_path__ + "static/media/contactless.d8363e0f.png";